import React from 'react'
import styled from '@emotion/styled'
import Tippy from '@tippyjs/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck, faCircleExclamation, faCircleInfo, faCircleX, faSquareCode } from '@fortawesome/pro-solid-svg-icons'

export const TIP_FONT_SIZE = '110%'

const iconsByName = {
	'info': { icon: faCircleInfo, color: 'orangeMain' },
	'dev': { icon: faSquareCode, color: 'goGreen' },
	'success': { icon: faCircleCheck, color: 'goGreen' },
	'warning': { icon: faCircleExclamation, color: 'orangeMain' },
	'error': { icon: faCircleX, color: 'stopRed' },
}

export const L1TipIcons = Object.keys(iconsByName)

const TipIcon = styled(FontAwesomeIcon)(({theme, color, leftPad, rightPad}) => ({
	marginLeft: leftPad ? theme.spacing(1) : 0,
	marginRight: rightPad ? theme.spacing(1) : 0,
	color: theme.colors[color],
	fontSize: '110%',
	'&:hover': {
		cursor: 'pointer',
	},
}))

const L1Tip = ({icon = "info", tip = "Lorem ipsum dolor sit amet, consectetur adipiscing elit.", leftPad = true, rightPad = true}) => {
	return (
		<Tippy content={tip} trigger="click">
			<TipIcon
				fixedWidth
				icon={iconsByName[icon].icon || faCircleInfo}
				color={iconsByName[icon].color}
				leftPad={leftPad}
				rightPad={rightPad}
			/>
		</Tippy>
	)
}

export default L1Tip
